import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=2de86aa4&scoped=true&"
import script from "./Categories.js?vue&type=script&lang=js&"
export * from "./Categories.js?vue&type=script&lang=js&"
import style0 from "./Categories.css?vue&type=style&index=0&id=2de86aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de86aa4",
  null
  
)

export default component.exports